/* eslint-disable import/no-cycle */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */
import {
  StateCreator, UseBoundStore, StoreApi, create,
} from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { createJSONStorage, persist } from 'zustand/middleware';
import type { MTImageEditorClass } from 'mt-image-editor-sdk';
import { ChatGeneratorMedias, InputStatusType, PPTOutlineType } from '$/pages/RoboneoChatBoard/type';

import { ReadyState } from '../api/fetchSSE.types';

// 通用的 Canvas 对象类型,避免直接依赖 @meitu/whee-infinite-canvas
export type CanvasObject = any;

export interface HTMLOptions {
  url: string;
}
interface TChatBoardState {
  readyState: ReadyState;
  isNeedPayCard: boolean;
  isPaySuccessContainueSSE: boolean;
  mediaList: ChatGeneratorMedias[];
  latestMediaFabric: undefined | CanvasObject;
  userUploadMediaFabric: CanvasObject[];
  pptOutline: PPTOutlineType | undefined;
  pptInstance: MTImageEditorClass | undefined;
  feedbackCallback?: () => void;
  inputStatus: InputStatusType; //  request 问询模式
}
const chatBoard: StateCreator<TChatBoardState, [
  ['zustand/immer', never],
]> = (set, get) => ({
  readyState: ReadyState.Closed,
  isPaySuccessContainueSSE: false,
  isNeedPayCard: false,
  mediaList: [],
  latestMediaFabric: undefined,
  pptOutline: undefined,
  pptInstance: undefined,
  inputStatus: 'custom',
  userUploadMediaFabric: [],
});

// @ts-ignore
const useChatBoardStore: UseBoundStore<StoreApi<TChatBoardState>> = create<TChatBoardState>()(persist(immer(chatBoard), {
  name: 'ppt-out-line',
  storage: createJSONStorage(() => sessionStorage),
  partialize: (state) => ({ pptOutline: state.pptOutline }),
}));
export default useChatBoardStore;

/**
 *  sse的状态
 */
export const setSSEState = (status: ReadyState) => {
  useChatBoardStore.setState(() => {
    return {
      readyState: status,
    };
  });
};

/**
 * 追击 订阅卡片消息
 */

export const setNeedPayCard = (isNeed: boolean) => {
  useChatBoardStore.setState(() => {
    return {
      isNeedPayCard: isNeed,
    };
  });
};

/**
 *  确认需要订阅ai卡片 需要查询sse 调用
 */
export const needPayCard = () => {
  useChatBoardStore.setState(() => {
    return {
      isNeedPayCard: true,
    };
  });
};

/**
 *  暂时先保留
 */
export const setMediaList = (list: ChatGeneratorMedias[]) => {
  useChatBoardStore.setState(() => {
    return {
      mediaList: list,
    };
  });
};

/**
 * design 卡片的插入的媒体资源
 */
export const updateMediaFabricObject = (instance: CanvasObject | undefined) => {
  useChatBoardStore.setState(() => {
    return {
      latestMediaFabric: instance,

    };
  });
};

export const setUserUploadMediaFabric = (userMediaItems: CanvasObject[]) => {
  useChatBoardStore.setState(() => {
    return {
      userUploadMediaFabric: userMediaItems,
    };
  });
};
/**
 * ppt 大纲参数
 */
export const setPPToutline = (outline: PPTOutlineType) => {
  useChatBoardStore.setState(() => ({
    pptOutline: outline,
  }));
};

/**
 * ppt 实例
 */
export const setPPTInstance = (instance: MTImageEditorClass) => {
  useChatBoardStore.setState(() => ({
    pptInstance: instance,
  }));
};
/**
 *
 */
export const setInputStatus = (status: InputStatusType) => {
  useChatBoardStore.setState(() => ({
    inputStatus: status,
  }));
};

export const needPaySuccessContainueSSE = () => {
  useChatBoardStore.setState(() => ({
    isPaySuccessContainueSSE: true,
  }));
};
